// Layout Components
import AppHeader from './src/components/layouts/AppHeader.vue';
import AppSidebar from './src/components/layouts/AppSidebar.vue';
import AppFooter from './src/components/layouts/AppFooter.vue';

// UI Components
import BaseButton from './src/components/ui/BaseButton.vue';
import BaseInput from './src/components/ui/BaseInput.vue';

// Home Components
import HeroSlider from './src/components/home/HeroSlider.vue';
import ProductCard from './src/components/home/ProductCard.vue';
import ProductSection from './src/components/home/ProductSection.vue';
import Sidebar from './src/components/home/Sidebar.vue';
import HomeBanner from './src/components/home/HomeBanner.vue';
import CategoriesGrid from './src/components/home/CategoriesGrid.vue';

// Home view
import Home from './src/views/Home.vue';

// Auth Components
import Login from './src/views/auth/Login.vue';
import Register from './src/views/auth/Register.vue';
import VerifyEmail from './src/views/auth/VerifyEmail.vue';
import ForgotPassword from './src/views/auth/ForgotPassword.vue';
import ResetPassword from './src/views/auth/ResetPassword.vue';
import Address from './src/views/auth/Address.vue';

// Product Components
import ProductList from './src/views/products/ProductList.vue';
import ProductDetail from './src/views/products/ProductDetail.vue';

// Category Components
import CategoryList from './src/views/categories/CategoryList.vue';
import CategoryShow from './src/views/categories/CategoryShow.vue';
import SubcategoryShow from './src/views/categories/SubcategoryShow.vue';
import SubsubcategoryShow from './src/views/categories/SubsubcategoryShow.vue';

// Collection Components
import CollectionsList from './src/views/collections/CollectionsList.vue';

// Brand Components
import BrandList from './src/views/brands/BrandList.vue';
import BrandShow from './src/views/brands/BrandShow.vue';

// Cart Components
import Cart from './src/views/cart/Cart.vue';

// Order Components
import Checkout from './src/views/orders/Checkout.vue';
import Payment from './src/views/orders/Payment.vue';
import PaymentSuccess from './src/views/orders/PaymentSuccess.vue';
import OrderDetail from './src/views/orders/OrderDetail.vue';

// Tracking Components
import Tracking from './src/views/tracking/Tracking.vue';

// Page Components
import Search from './src/views/search/Search.vue';
import About from './src/views/pages/About.vue';
import Policies from './src/views/pages/Policies.vue';
import Refund from './src/views/pages/Refund.vue';
import Terms from './src/views/pages/Terms.vue';
import Collection from './src/views/pages/Collection.vue';
import RecentlyViewed from './src/views/pages/RecentlyViewed.vue';
import NotFound from './src/views/pages/NotFound.vue';
import HelpCenter from './src/views/pages/HelpCenter.vue';
import ContactUs from './src/views/pages/ContactUs.vue';

const components = {
  // Layouts
  appheader: AppHeader,
  appsidebar: AppSidebar,
  appfooter: AppFooter,

  // UI
  basebutton: BaseButton,
  baseinput: BaseInput,

  // Home
  heroslider: HeroSlider,
  productcard: ProductCard,
  productsection: ProductSection,
  sidebar: Sidebar,
  homebanner: HomeBanner,
  categoriesgrid: CategoriesGrid,

  // Auth
  login: Login,
  register: Register,
  verifyemail: VerifyEmail,
  forgotpassword: ForgotPassword,
  resetpassword: ResetPassword,
  'address-form': Address,

  // Products
  productlist: ProductList,
  productdetail: ProductDetail,

  // Categories
  categorylist: CategoryList,
  categoryshow: CategoryShow,
  subcategoryshow: SubcategoryShow,
  'subcategory-show': SubcategoryShow,
  subsubcategoryshow: SubsubcategoryShow,
  'subsubcategory-show': SubsubcategoryShow,

  // Collections
  'collections-list': CollectionsList,

  // Brands
  'brand-list': BrandList,
  'brand-show': BrandShow,

  // Cart
  cart: Cart,

  // Orders
  checkout: Checkout,
  payment: Payment,
  'payment-success': PaymentSuccess,
  'order-detail': OrderDetail,

  // Tracking
  tracking: Tracking,

  // Pages
  home: Home,
  search: Search,
  about: About,
  policies: Policies,
  refund: Refund,
  terms: Terms,
  collection: Collection,
  recentlyviewed: RecentlyViewed,
  notfound: NotFound,
  'help-center': HelpCenter,
  'contact-us': ContactUs,
};

export default components;
